export const VALIDATION_PATTERN = 'iddqd'
